import { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { responsiveAppBarStyles } from "../ResponsiveNavbar/styles";
import { CustomTextField } from "../TracksPageComponents/styles";
import { ProjectSearchBarProps } from "./types";
import CustomButton from "../CustomButton/CustomButton";

export const ProjectSearchBar: React.FC<ProjectSearchBarProps> = ({
  queryValue,
  setQueryValue,
  setPage,
  setProjects,
}) => {
  const [query, setQuery] = useState<string>("");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width: 1536px)");

  const escapeRegex = (input: string) => {
    return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    if (e.target.value.trim() === "") {
      setQueryValue("");
      setPage(0);
      setProjects([]);
    }
  };

  useEffect(() => {
    if (queryValue === "") {
      setQuery("");
    }
  }, [queryValue]);

  const handleEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && query.trim() !== "") {
      setQueryValue(escapeRegex(query.trim()));
      setPage(0);
      setProjects([]);
    }
  };

  return (
    <>
      <CustomTextField
        sx={{ width: isSmallScreen ? "90vw" : "300px" }}
        value={query}
        placeholder="Search projects"
        onKeyPress={handleEnterPress}
        size={isSmallScreen ? "small" : "medium"}
        onChange={handleQueryChange}
        InputProps={{
          endAdornment: (
            <Fragment>
              <CustomButton
                onClick={() => {
                  if (query.trim() !== "") {
                    setQueryValue(escapeRegex(query.trim()));
                    setPage(0);
                    setProjects([]);
                  }
                }}
                text="Search"
              />
            </Fragment>
          ),
        }}
      />
    </>
  );
};
